import React from 'react';

const SignUpIn = () => {
    return (
        <>
            <h1>Sign Up In Out Page</h1>
        </>
    );
};

export default SignUpIn;